/** @format */

import { Fragment, useEffect, useState } from 'react';
import { useDispatch } from 'src/store';
import { resetError } from 'src/slices/global';
import { Header } from 'src/components';
import { Footer } from 'src/components';
import { resolveSelectedLanguage, setAppLanguage } from 'src/utils/locale';
import NotFound from './NotFound';

const NotFoundView = () => {
  const dispatch = useDispatch();
  const [userLang, setLang] = useState(() => resolveSelectedLanguage());
  useEffect(() => {
    dispatch(resetError());
  });
  const getSelectLang = async e => {
    const { value } = e.target;
    const lang = await setAppLanguage(value, { manual: true });
    setLang(lang);
  };

  return (
    <Fragment>
      <Header getSelectLang={getSelectLang} userLang={userLang} />
      <NotFound />
      <Footer />
    </Fragment>
  );
};

export default NotFoundView;
